// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footerCopywright":"Footer_footerCopywright__23yTv","footerMisc":"Footer_footerMisc__2vtgI","divider":"Footer_divider__1X_Hx"};